export const getOS = () => {
	const { userAgent } = window.navigator

	const osMap: Record<string, RegExp> = {
		isMac: /Macintosh|MacIntel|MacPPC|Mac68K/,
		isIOS: /iPhone|iPad|iPod/,
		isWindows: /Windows|Win32|Win64/,
		isAndroid: /Android/i,
		isLinux: /Linux/,
	}

	const osInfo: Record<string, boolean> = {}

	for (const [key, regex] of Object.entries(osMap)) {
		osInfo[key] = regex.test(userAgent)
	}

	return osInfo
}
